import { FormattedMessage } from 'react-intl';

type Props = { href: string };
export function TraceLink({ href }: Props) {
  return (
    <a className="btn btn-danger" href={href} target="_blank">
      <FormattedMessage id="errorForm.traceLink" />
    </a>
  );
}
